import { MeasureText } from "./MeasureText";

export function MeasureText2(theText, fontString) {
  var pixel5 = MeasureText(theText, fontString) * 1.05;
  var lengthInPixels = parseInt(pixel5);
  return lengthInPixels;
}
